export default __webpack_public_path__ + "static/media/info-icon.84ed02dc.png";